import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrendingUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M3 17l6 -6l4 4l8 -8" }), /* @__PURE__ */ _jsx("path", { d: "M14 7l7 0l0 7" })]
});
export { SvgTrendingUp as ReactComponent };
